import { render, staticRenderFns } from "./step-counter.vue?vue&type=template&id=0428a864&scoped=true"
import script from "./step-counter.vue?vue&type=script&lang=js"
export * from "./step-counter.vue?vue&type=script&lang=js"
import style0 from "./step-counter.vue?vue&type=style&index=0&id=0428a864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428a864",
  null
  
)

export default component.exports